/* eslint-disable default-case */
import React, { useEffect, useState } from "react";
import Outlet from "../Outlet";
import "../../assets/Css/ListingsManagement.css";
import { PiStickerDuotone } from "react-icons/pi";
import { IoTrendingDown } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { CiSearch } from "react-icons/ci";
import axios from "axios";

const ListingsManagement = () => {
  const [selectedRange, setSelectedRange] = useState("All");
  const [products, setProducts] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [productsPerPage, setProductsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalProducts, setTotalProducts] = useState(0);
  const [searchTerm, setSearchTerm] = useState(""); // ✅ Add search state
  const [selectedRow, setSelectedRow] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchProducts();
  }, [currentPage, productsPerPage, searchTerm]); // ✅ searchTerm dependency add kari

  const fetchProducts = async () => {
    try {
      const res = await axios.get(`https://network.rentel.in/admin/products`, {
        params: {
          isDelete: false,
          page: currentPage,
          limit: productsPerPage,
          search: searchTerm || undefined, // ✅ Pass search param
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      });

      setProducts(res.data.products || []);
      setTotalProducts(res.data.total || res.data.products.length);
    } catch (err) {
      // console.error("Error fetching user products:", err);
    }
  };

  const handleViewClick = (product) => {
    navigate(`/ProductDetails`, {
      state: { product },
    });
  };
  // Row click/select function
  const handleRowSelect = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((row) => row !== id) : [...prev, id]
    );
  };

  const onPageChange = (page, limit = productsPerPage) => {
    setProductsPerPage(limit);
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(totalProducts / productsPerPage);
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  const deleteProduct = async (productId, hard = false) => {
    try {
      const token = localStorage.getItem("adminToken");
      const url = `https://network.rentel.in/admin/products/${productId}?hard=${hard}`;

      const response = await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // console.log("Product deleted:", response.data);
      return response.data;
    } catch (error) {
      // console.error(
      //   "Error deleting product:",
      //   error.response?.data || error.message
      // );
      throw error;
    }
  };

  const filterByDateRange = (products, selectedRange) => {
    const today = new Date();
    let startDate;
    let endDate = today;

    switch (selectedRange) {

      case "All":
        return products; // 🔥 no filter, return everything

      case "Last 6 Months":
        startDate = new Date(
          today.getFullYear(),
          today.getMonth() - 6,
          today.getDate()
        );
        break;

      case "Last Month":
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        endDate = new Date(today.getFullYear(), today.getMonth(), 0);
        break;

      case "Last Week":
        startDate = new Date();
        startDate.setDate(today.getDate() - 7);
        break;

      case "Today":
        startDate = new Date(today);
        startDate.setHours(0, 0, 0, 0);

        endDate = new Date(today);
        endDate.setHours(23, 59, 59, 999);
        break;

      default:
        return products; // fallback → All
    }

    return products.filter((p) => {
      if (!p.createdAt) return false;

      const created = new Date(p.createdAt);
      return created >= startDate && created <= endDate;
    });
  };



  const filteredProducts = filterByDateRange(products, selectedRange).filter((p) =>
    (p.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      p.category?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      p.vendorName?.toLowerCase().includes(searchTerm.toLowerCase())) &&
    p.isDelete === false
  );



  return (
    <Outlet>
      <div className="dashboard-titlead">
        <h2 className="dashboard-titlead">Listing Management</h2>
        <select
          className="dashboard-filter"
          value={selectedRange}
          onChange={(e) => setSelectedRange(e.target.value)}
        >
          <option>All</option>
          <option>Last 6 Months</option>
          <option>Last Month</option>
          <option>Last Week</option>
          <option>Today</option>
        </select>
      </div>

      {/* Card */}
      <div className="user-carda">
        <div className="gap-uppua">
          <div className="user-headera">
            <div className="user-icon-bga">
              <PiStickerDuotone className="user-iconi" />
            </div>
            <div className="user-datae">
              <span className="labela">Total Listing</span>
              <p className="counta">{totalProducts}</p>
            </div>
          </div>
          <div className="user-footers">
            <div className="growth-downs">
              <IoTrendingDown className="trend-icona" />
              <span className="percentages">1.06%</span>
            </div>
            <span className="notea">from last week</span>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="pl-container">
        <div className="pl-searchs">
          <h3 className="pl-title">Product Listing</h3>
          <div className="user-controlsa">
            <CiSearch className="search-icon" />
            <input
              type="text"
              className="search-box"
              placeholder="Search product name"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1); // ✅ Reset to first page on search
              }}
            />
          </div>
        </div>
        <table className="pl-table">
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedRows(products.map((p) => p.id));
                    } else {
                      setSelectedRows([]);
                    }
                  }}
                  checked={
                    selectedRows.length === products.length &&
                    products.length > 0
                  }
                />
              </th>
              <th>ID</th>
              <th>Product</th>
              <th>Category</th>
              <th>Buy Price</th>
              <th>Posted By</th>
              <th>Listing Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredProducts.map((p) => (
              <tr key={p._id}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedRows.includes(p._id)}
                    onChange={() => handleRowSelect(p._id)}
                  />
                </td>

                <td>{p._id}</td>

                <td className="pl-product-cell">
                  <img
                    src={Array.isArray(p.images) ? p.images[0] : p.images}
                    alt={p.title}
                    className="pl-product-img"
                  />
                  {p.title}
                </td>

                <td>{p.category}</td>
                <td>{p.price}</td>
                <td>{p.vendorName}</td>

                <td>
                  {p.createdAt
                    ? new Date(p.createdAt).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })
                    : "N/A"}
                </td>

                <td>
                  <button className="view-btn" onClick={() => handleViewClick(p)}>
                    View
                  </button>

                  <button
                    className="pl-btn-delete"
                    disabled={!selectedRows.includes(p._id)}
                    onClick={() => {
                      deleteProduct(p._id, false).then(() => {
                        setProducts((prev) =>
                          prev.filter((item) => item._id !== p._id)
                        );
                        setSelectedRows((prev) =>
                          prev.filter((id) => id !== p._id)
                        );
                      });
                    }}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>

        </table>

        {/* Pagination Footer */}
        <div className="pl-footer">
          <div className="pl-showing">
            Showing
            <select
              value={productsPerPage}
              onChange={(e) => onPageChange(1, parseInt(e.target.value))}
            >
              <option value={10}>10</option>
              <option value={20}>20</option>
            </select>
            of {totalProducts}
          </div>
          <div className="pl-pagination">
            {pages.map((page) => (
              <button
                key={page}
                className={`pl-page-btn ${currentPage === page ? "active" : ""
                  }`}
                onClick={() => onPageChange(page)}
              >
                {page}
              </button>
            ))}
          </div>
        </div>
      </div>
    </Outlet>
  );
};

export default ListingsManagement;
